export const HELP_URL =
  "https://help.chargeback.io/en/articles/12782785-how-to-get-bins-caid-for-rdr-alerts"

export const BILLING_DESCRIPTOR_ARTICLE_URL =
  "https://help.chargeback.io/en/articles/15595441-find-your-billing-descriptors-and-arns"
